<template>
  <hm-content title="促销列表">
    <div slot="header">
      <hm-step
        :steps="steps"
        :step="3"
        :disabledFirst="disabledFirst"
        disabledNext
      ></hm-step>
    </div>
    <div class="selected-activity caption">
      <span class="mr10">促销内容</span>
      <span class="primary activity">({{ childTypeName }})</span>
    </div>
    <div class="flex flex-between table-panel">
      <div>
        <el-button type="primary" @click="add('brand', '添加品牌')" size="small"
          >添加品牌</el-button
        >
        <el-button type="primary" @click="add('goods', '添加商品')" size="small"
          >添加商品</el-button
        >
        <el-button type="primary" @click="add('barcode', '添加sku商品')" size="small"
          >添加sku商品</el-button
        >
        <el-button
          type="primary"
          @click="addDrawer('category', '添加品类')"
          size="small"
          >添加品类</el-button
        >
        <el-button
          type="primary"
          @click="addDrawer('attribute', '添加属性')"
          size="small"
          >添加属性</el-button
        >
      </div>

      <el-input
        size="small"
        v-model="keywords"
        @input="filterGoods"
        placeholder="货号/商品关键字"
        suffix-icon="hmicon icon-search"
      ></el-input>
    </div>
    <div class="flex flex-between table-panel">
      <div class="flex flex-wrap">
        <el-switch
          v-model="goodsType"
          size="mini"
          active-color="#ff4949"
          inactive-color="#ff4949"
          active-value="goodsSn"
          active-text="按货号"
          inactive-text="按条码"
          inactive-value="barcode"
          class="mr10"
        >
        </el-switch>
        <div @click="outputExcel" class="delete mr20 pointer">
          <span class="delete-icon hmicon icon-daochu"></span>
          导出模板
        </div>
        <div class="delete mr20 pointer open-file">
          <span class="delete-icon hmicon icon-daoru"></span>
          导入商品<span class="primary">({{goodsType==='goodsSn'?"按货号":"按条码"}})</span>
          <input
            type="file"
            @change="importf"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          />
        </div>
      </div>
      <div @click="batchSetting" class="pointer">
        <span class="delete-icon hmicon icon-shanchu "></span>
        批量删除
      </div>
    </div>
    <div class="table">
      <!-- <div class="table-out-header flex flex-between">
        <div>
          <el-checkbox
            :indeterminate="isIndeterminate"
            v-model="checkAll"
            @change="handleCheckAllChange"
            >全选</el-checkbox
          >
        </div>
        <div>已选商品</div>
        <div @click="deleteSelected" class="delete">
          <span class="delete-icon hmicon icon-shanchu"></span>
          删除
        </div>
      </div>
      <div class="table-header flex flex-between">
        <div class="flex-1 num">商品货号</div>
        <div class="flex-3 text-center">商品名</div>
        <div class="flex-1 text-center">数量</div>
        <div class="flex-1 text-center">状态</div>
        <div class="flex-1 text-center">操作</div>
      </div>
      <div class="table-body">
        <el-scrollbar
          ref="scrollContainer"
          :vertical="false"
          wrap-style="max-height: 500px;"
        >
          <el-checkbox-group
            v-model="checkedGoods"
            @change="handleCheckedGoodsChange"
          >
            <div class="list-item" v-for="(v, i) in result" :key="i">
              <div class="row flex flex-between">
                <el-checkbox :label="v" class="flex-1 flex item-center">{{
                  v.attrId
                }}</el-checkbox>
                <div
                  class="flex-3 flex flex-center"
                  style="box-sizing: border-box; padding-left: 10px"
                >
                  <span>{{ v.attrValue }}</span>
                </div>
                <div class="flex-1 text-center">{{ v.goodsPackageNum }}</div>
                <div class="flex-1 text-center">
                  <span v-if="v.useable === 'white'" class="select-type white"
                    >白</span
                  >
                  <span v-if="v.useable === 'black'" class="select-type black"
                    >黑</span
                  >
                </div>
                <div
                  class="flex-1 text-center"
                  @click="deleteCurrentGoods(v, i)"
                >
                  <span class="primary delete-icon hmicon icon-shanchu"></span>
                </div>
              </div>
            </div>
          </el-checkbox-group>
        </el-scrollbar>
        <div class="no-message text-center" v-show="!result.length">
          请添加商品!
        </div>
      </div> -->
      <el-table
        stripe
        border
        @selection-change="getBatchChecked"
        :data="result"
        style="width: 100%"
        id="table"
        size="small"
        height="500"
      >
        <el-table-column type="selection"></el-table-column>
        <el-table-column type="index" label="序号"></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="attrType"
          label="添加状态"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.attrType === 'brand'">
              添加品牌
            </div>
            <div v-if="scope.row.attrType === 'goods'">
              添加商品
            </div>
            <div v-if="scope.row.attrType === 'barcode'">
              添加sku商品
            </div>
            <div v-if="scope.row.attrType === 'category'">
              添加品类
            </div>
            <div v-if="scope.row.attrType === 'attribute'">
              添加属性
            </div>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="attrType"
          label="编号（只显示商品货号/条码）"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.attrType === 'goods'">
              货号:{{ scope.row.attrId }}
            </div>
            <div v-else-if="scope.row.attrType === 'barcode'">
              条码:{{ scope.row.attrId }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="attrValue"
          label="名称"
          width="500"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="shopPrice"
          label="零售价"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="useable"
          label="状态"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.useable === 'white'" class="select-type white"
              >白</span
            >
            <span v-if="scope.row.useable === 'black'" class="select-type black"
              >黑</span
            >
          </template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tooltip class="item" content="删除" placement="top">
              <div class="pointer mr10" @click="remove(scope.$index)">
                <span class="hmicon icon-shanchu primary"></span>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="flex flex-center mt10">
      <el-button type="primary" size="small" @click="back">上一步</el-button>
      <el-button type="primary" size="small" @click="nextStep('ruleForm')"
        >下一步</el-button
      >
    </div>
    <el-dialog
      :title="title"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="1200px"
    >
      <div v-if="type === 'brand'">
        <div class="table-panel flex flex-end">
          <el-input
            clearable
            v-model.trim="searchCondition.keyWords"
            placeholder="搜索品牌"
            size="small"
            class="ipt mr10"
          ></el-input>
          <el-button type="primary" size="small" @click="searchAdd"
            >查询</el-button
          >
        </div>

        <el-table
          @sort-change="sortChange"
          stripe
          border
          ref="table"
          :data="addList"
          style="width: 100%"
          id="table"
          size="small"
          @selection-change="getChecked"
          :default-sort="{ prop: 'num', order: 'descending' }"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column
            type="index"
            label="序号"
            header-align="center"
            align="center"
            :index="index => index + (currentPageAdd - 1) * pageSizeAdd + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="brandName"
            label="品牌名称"
          >
            <template slot-scope="scope">
              {{ scope.row.brandName }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            show-overflow-tooltip
            align="center"
            prop="brandLogo"
            label="品牌logo图"
          >
            <template slot-scope="scope">
              <img
                :src="scope.row.brandLogo"
                alt
                style="width:60px;height:60px"
                v-if="scope.row.brandLogo"
              />
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="brandAcronym"
            label="品牌首字母"
            sortable
          >
            <template slot-scope="scope">
              {{ scope.row.brandAcronym }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="relationSpu"
            label="相关商品"
            sortable
          >
            <template slot-scope="scope">
              {{ scope.row.relationSpu }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-if="type === 'goods'">
        <div class="table-panel flex flex-end">
          <el-input
            clearable
            style="width: 300px"
            v-model.trim="searchCondition.keyWords"
            size="small"
            :placeholder="placeholder"
            class="ipt mr10"
          >
            <el-select
              slot="prepend"
              size="small"
              style="width:100px"
              @change="selectQueryType"
              v-model="searchCondition.queryType"
            >
              <el-option label="商品名" value="spu_name"></el-option>
              <el-option label="货号" value="goods_sn"></el-option>
              <el-option label="条码" value="spec_barcode"></el-option>
            </el-select>
          </el-input>
          <el-button type="primary" size="small" @click="searchAdd"
            >查询</el-button
          >
        </div>
        <el-table
          stripe
          border
          ref="table"
          :data="addList"
          style="width: 100%"
          id="table"
          size="small"
          @selection-change="getChecked"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column
            type="index"
            label="序号"
            header-align="center"
            align="center"
            :index="index => index + (currentPageAdd - 1) * pageSizeAdd + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="wxshopSpuName"
            label="商品名称"
          >
            <template slot-scope="scope">
              {{ scope.row.wxshopSpuName }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="brandName"
            label="商品品牌"
          >
            <template slot-scope="scope">
              {{ scope.row.brandName }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="goodsSn"
            label="商品货号"
          >
            <template slot-scope="scope">
              {{ scope.row.goodsSn }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="spuBarcode"
            label="商品条码"
          >
            <template slot-scope="scope">
              {{ scope.row.spuBarcode }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="showPrice"
            label="商品零售价"
          >
            <template slot-scope="scope">
              {{ scope.row.showPrice }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-if="type === 'barcode'">
        <div class="table-panel flex flex-end">
          <el-input
            clearable
            style="width: 300px"
            v-model.trim="searchCondition.barcode"
            size="small"
            placeholder="请输入商品条码"
            class="ipt mr10"
          >
          </el-input>
          <el-button type="primary" size="small" @click="searchAdd"
            >查询</el-button
          >
        </div>
        <el-table
          stripe
          border
          ref="table"
          :data="addList"
          style="width: 100%"
          id="table"
          size="small"
          @selection-change="getChecked"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column
            type="index"
            label="序号"
            header-align="center"
            align="center"
            :index="index => index + (currentPageAdd - 1) * pageSizeAdd + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="goodsName"
            label="商品名称"
            column-key="goodsName"
          >
            <template slot-scope="scope">
              {{ scope.row.goodsName }}
            </template>
          </el-table-column>
          <!-- <el-table-column
            header-align="center"
            align="center"
            prop="brandName"
            label="商品品牌"
          >
            <template slot-scope="scope">
              {{ scope.row.brandName }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="goodsSn"
            label="商品货号"
          >
            <template slot-scope="scope">
              {{ scope.row.goodsSn }}
            </template>
          </el-table-column> -->
          <el-table-column
            header-align="center"
            align="center"
            prop="barcode"
            label="商品条码"
            column-key="barcode"
          >
            <template slot-scope="scope">
              {{ scope.row.barcode }}
            </template>
          </el-table-column>
           <el-table-column
            header-align="center"
            align="center"
            prop="showPrice"
            label="商品售价"
            column-key="showPrice"
          >
            <template slot-scope="scope">
              {{ scope.row.showPrice }}
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="hm-pagination">
        <el-pagination
          background
          :total="totalAdd"
          @current-change="pagingAdd"
          @size-change="handleSizeChangeAdd"
          :page-sizes="[10, 50, 100, 200]"
          layout="total, sizes,  prev, pager, next, jumper"
          :current-page="currentPageAdd"
        ></el-pagination>
      </div>

      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="addSelected('white')" size="small" type="primary"
          >加为白名单</el-button
        >
        <el-button @click="addSelected('black')" size="small" type="primary"
          >加为黑名单</el-button
        >
        <!-- <el-button @click="saveSelected" size="small" type="primary"
          >保存</el-button
        > -->
        <el-button @click="dialogVisible = false" size="small">取消</el-button>
      </span>
    </el-dialog>
    <el-drawer
      custom-class="hm-drawer"
      :title="title"
      :wrapperClosable="false"
      :visible.sync="drawer"
      :before-close="handleClose"
    >
      <div class="drawer-content" v-if="type === 'category'">
        <div class="caption">所有的品类：</div>
        <el-input
          placeholder="输入关键字进行搜索"
          clearable
          v-model="filterText"
          size="small"
        >
        </el-input>
        <el-tree
          v-if="type === 'category'"
          :filter-node-method="filterNode"
          empty-text="暂无品类"
          :props="props"
          node-key="attrId"
          ref="tree"
          :load="loadNode"
          lazy
          highlight-current
          show-checkbox
        ></el-tree>
      </div>
      <div class="drawer-content" v-if="type === 'attribute'">
        <div class="caption">所有的属性：</div>
        <el-input
          placeholder="输入关键字进行搜索"
          clearable
          v-model="filterText"
          size="small"
        >
        </el-input>
        <el-tree
          v-if="type === 'attribute'"
          :filter-node-method="filterNode"
          empty-text="暂无属性"
          :props="props"
          node-key="attrId"
          ref="tree"
          :load="loadNode"
          lazy
          highlight-current
          show-checkbox
        ></el-tree>
      </div>
      <div class="drawer-footer flex flex-center ">
        <el-button @click="addSelected('white')" size="small" type="primary"
          >加为白名单</el-button
        >
        <el-button @click="addSelected('black')" size="small" type="primary"
          >加为黑名单</el-button
        >
        <el-button size="small" @click="handleClose">取 消</el-button>
      </div>
    </el-drawer>
    <el-dialog :visible.sync="errValidGoods" width="30%" title="提示">
      <div>
        <div>
          您有
          <span class="error">{{ errInputResult.length }}</span
          >条数据有误未导入
        </div>
        <el-table :data="errInputResult" border class="small-table">
          <el-table-column prop="goodsSn" label="错误货号">
            <template slot-scope="scope">
              {{ scope.row }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
import HmStep from "@/components/HmStep";
// import HmTransfer from "@/components/HmTransfer";
import {
  getCookie,
  setCookie,
  queryActivityCategory,
  arrayUnique2
} from "@/utils/utils";
import { mapGetters } from "vuex";
import XLSX from "xlsx";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串

export default {
  data() {
    return {
      goodsType: "goodsSn",
      errInputResult: [],
      errValidGoods: false,
      props: {
        value: "attrId",
        label: "attrValue",
        children: "children",
        isLeaf: "leaf"
      },
      title: "",
      drawer: false,
      placeholder: "请输入商品名",
      checkedRowList: [],
      searchCondition: {
        queryType: ""
      },
      addList: [],
      checkedRow: [],
      type: "",
      disabledFirst: false,
      childTypeName: "",
      checkedGoods: [],
      leftRules: [],
      subType: "",
      checkAll: false,
      isIndeterminate: false,
      result: [],
      selectedData: [],
      keywords: "",
      dialogVisible: false,
      steps: [
        {
          link: "SelectActivity",
          name: "选择促销类型"
        },
        {
          link: "CreatActivity",
          name: "创建促销"
        },
        {
          link: "GoodsManagement",
          name: "管理促销商品"
        },
        {
          link: "CreatGoodsRule",
          name: "创建规则"
        }
      ],
      currentPageAdd: 1,
      pageSizeAdd: 10,
      totalAdd: 0,
      filterText: "",
      sort: {}
    };
  },
  computed: mapGetters([
    "offlineCategoryList",
    "offlineBrandList",
    "offlineGoodsList"
  ]),
  created() {
    const { type, subType } = this.$route.query;
    this.subType = subType;
    this.disabledFirst = type === "edit";
  },
  mounted() {
    const STEP = getCookie({ key: "STEP" });

    this.childTypeName = queryActivityCategory({
      parentId: STEP.step1.parentId,
      childId: STEP.step1.childId
    }).childTypeName;
    if (STEP.step3) {
      STEP.step3.forEach(v => {
        v.shopPrice = v.shopPrices ? v.shopPrices : v.shopPrice;
      });
      this.selectedData = STEP.step3;
      this.result = this.selectedData;
    }
  },
  beforeDestroy() {
    const data = getCookie({ key: "STEP" });
    data.step3 = this.result;
    setCookie({ key: "STEP", data });
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    result(val) {
      if (!val.length) {
        this.checkAll = false;
      }
    }
  },
  methods: {
    // 导出excel
    outputExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader =
          this.goodsType === "goodsSn"
            ? ["商品货号(单次最多导入200条)"]
            : ["商品条码(单次最多导入200条)"];
        const data = [["ABC123"]];

        exportJsonToExcel(tHeader, data, "模板");
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    // 导入excel
    importf(e) {
      const obj = e.target;
      const that = this;
      if (
        this.selectedData.length === 0 ||
        (this.selectedData.length > 0 &&
          this.selectedData.find(o => o.attrType !== "attribute"))
      ) {
        this.inputData = [];
        if (!obj.files) {
          return;
        }
        let f = obj.files[0];
        let reader = new FileReader();
        reader.onload = function(e) {
          let data = e.target.result;
          if (rABS) {
            wb = XLSX.read(btoa(this.fixdata(data)), {
              // 手动转化
              type: "base64"
            });
          } else {
            wb = XLSX.read(data, {
              type: "binary"
            });
          }
          let result = null;
          wb.SheetNames.forEach(sheetName => {
            let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
              header: 1
            });
            if (roa.length) {
              result = roa.slice(1);
            }
          });
          let formatResult = [];
          // let isValid = true;
          // let isRequired = true;
          let goodsSns = [];
          result.forEach(v => {
            v[0] = v[0] ? (v[0] + "").replace(/\s*/g, "") : "";
            if (v[0] !== "") {
              formatResult.push({
                goodsSn: v[0]
              });
            }
          });
          formatResult = arrayUnique2(formatResult, "goodsSn");
          goodsSns = formatResult.map(o => o.goodsSn);
          let importType = that.goodsType === "goodsSn" ? "goods" : "barcode";
          that.$store
            .dispatch("queryGoodsSnOffline", { goodsSns, importType })
            .then(res => {
              const { code, result } = res;
              if (code === "0") {
                if (result.notEffectiveGoods.length) {
                  that.errValidGoods = true;
                  that.errInputResult = result.notEffectiveGoods;
                  that.$message({
                    message: `部分${
                      that.goodsType === "goodsSn" ? "货号" : "条码"
                    }货号导入失败！`,
                    type: "warning"
                  });
                }
                if (that.goodsType === "goodsSn") {
                  result.effectiveGoods.forEach(v => {
                    v.attrValue = v.goodsName;
                    v.attrId = v.goodsSn;
                    v.attrType = "goods";
                  });
                } else {
                  result.effectiveGoods.forEach(v => {
                    v.attrValue = v.goodsName;
                    v.attrId = v.barcode;
                    v.attrType = "barcode";
                  });
                }

                result.effectiveGoods.forEach(v => {
                  v.useable = "white";
                });
                that.result.push(...result.effectiveGoods);

                that.result = arrayUnique2(that.result, "attrId");
                that.result.forEach(v => {
                  v.goodsPackageNum = 1;
                  if (v.goodsName) {
                    v.goodsInfo = v.goodsName;
                  }
                });
              }
            });
          // result.forEach(v => {
          //   if (!v[0] || !v[1] || !v[2]) {
          //     isRequired = false;
          //   } else {
          //     if (!that.isString(v[1]) || !that.isString(v[2])) {
          //       isValid = false;
          //       //   that.errValidGoods = true;
          //       //   that.errInputResult.push({
          //       //     name: v[0],
          //       //     mobile: v[1]
          //       //   });
          //     } else {
          //       goodsSns.push(v[0]);
          //       formatResult.push({
          //         goodsSn: (v[0] + "").replace(/ /g, ""),
          //         commissionStartTime: `${v[1]} 00:00:00`,
          //         commissionEndTime: `${v[2]} 23:59:59`,
          //         commissionType:
          //           v[3] === "固定返佣" ? "fixedReturn" : "ratioReturn",
          //         commissionValue: v[4] ? v[4] : "",
          //         agentDiscountValue: v[5] ? v[5] : ""
          //       });
          //     }
          //   }
          // });
          // if (isValid && isRequired) {
          //   let errList = formatResult.filter((item, index, self) => {
          //     for (let i = index + 1; i < self.length; i++) {
          //       if (self[i].goodsSn === item.goodsSn) {
          //         return true;
          //       }
          //     }
          //     return false;
          //   });

          //   if (errList.length > 0) {
          //     that.errValidGoods = true;
          //     that.errInputResult = errList;
          //     that.$message({
          //       message: "导入失败，有重复商品货号！",
          //       type: "warning"
          //     });
          //   } else {
          //     that.$store
          //       .dispatch("queryShareGoodsSn", { goodsSns })
          //       .then(res => {
          //         const { code, result } = res;
          //         if (code === "0") {
          //           if (result.resultList.length > 0) {
          //             that.distributionGoodList = [];
          //             result.resultList.forEach(v => {
          //               formatResult.forEach(item => {
          //                 if (v.goodsSn === item.goodsSn) {
          //                   that.distributionGoodList.push(
          //                     Object.assign({}, item, v)
          //                   );
          //                 }
          //               });
          //             });
          //           }
          //           if (result.errGoodsSns.length > 0) {
          //             that.errValidGoods = true;
          //             that.errInputResult = [];
          //             result.errGoodsSns.forEach(v => {
          //               that.errInputResult.push({ goodsSn: v });
          //             });
          //           }
          //         }
          //       });
          //   }
          // } else {
          //   if (!isRequired) {
          //     that.$message({
          //       message: "导入失败，请导入必填商品信息！",
          //       type: "warning"
          //     });
          //   } else if (!isValid) {
          //     that.$message({
          //       message: "导入失败，日期请使用文本格式导入！",
          //       type: "warning"
          //     });
          //   }
          // }
        };
        if (rABS) {
          reader.readAsArrayBuffer(f);
        } else {
          reader.readAsBinaryString(f);
        }
      } else {
        this.$message({
          type: "error",
          message: "属性标签不能与品牌、品类、商品共存！"
        });
      }
      obj.value = "";
    },
    isString(value) {
      return typeof value === "string";
    },
    fixdata(data) {
      // 文件流转BinaryString
      let o = "";
      let l = 0;
      let w = 10240;
      for (; l < data.byteLength / w; ++l)
        o += String.fromCharCode.apply(
          null,
          new Uint8Array(data.slice(l * w, l * w + w))
        );
      o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
      return o;
    },
    handleClose() {
      this.drawer = false;
      this.type = "";
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.attrValue.indexOf(value) !== -1;
    },
    getSimpleCheckedNodes(store) {
      const checkedNodes = [];
      const traverse = function(node) {
        const childNodes = node.root ? node.root.childNodes : node.childNodes;

        childNodes.forEach(child => {
          if (child.checked) {
            checkedNodes.push({
              attrId: child.data.attrId,
              attrValue: child.data.attrValue,
              attrType: child.data.attrType
            });
          }
          if (child.indeterminate) {
            traverse(child);
          }
        });
      };
      traverse(store);

      return checkedNodes;
    },
    loadNode(node, resolve) {
      // 一级节点处理
      if (node.level === 0) {
        this.requestTree(resolve);
      }
      // 其余节点处理
      if (node.level >= 1) {
        // 注意！把resolve传到你自己的异步中去
        this.getIndex(node, resolve);
      }
    },
    requestTree(resolve) {
      if (this.type === "category") {
        this.$store
          .dispatch("queryGoodsCategoryTree", {
            categoryLevel: 1
          })
          .then(res => {
            const data = res.result;
            data.forEach(v => {
              v.attrId = v.categoryId;
              v.attrValue = v.categoryName;
              v.attrType = "category";
            });
            let categoryList = [];
            this.result.map(v => {
              if (v.attrType === "category") {
                categoryList.push(v);
              }
            });
            let check = categoryList.map(o => o.attrId);
            this.$refs.tree.setCheckedKeys(check);
            resolve(data);
          })
          .catch(err => {
            throw new Error(err);
          });
      } else {
        this.$store
          .dispatch("queryAttributeType")
          .then(res => {
            const data = res.result;
            data.forEach(v => {
              v.attrId = v.typeId;
              v.attrValue = v.typeName;
              v.attrType = "attribute";
              // v.disabled = true;
            });
            let attributeList = [];
            this.result.map(v => {
              if (v.attrType === "attribute") {
                attributeList.push(v);
              }
            });
            let check = attributeList.map(o => o.attrId);
            this.$refs.tree.setCheckedKeys(check);
            resolve(data);
          })
          .catch(err => {
            throw new Error(err);
          });
      }
    },
    // 异步加载叶子节点数据函数
    getIndex(node, resolve) {
      if (this.type === "category") {
        this.$store
          .dispatch("queryGoodsCategoryTree", {
            parentCategoryId: node.data.categoryId,
            categoryLevel: node.level + 1
          })
          .then(res => {
            const data = res.result;
            data.forEach(v => {
              v.attrId = v.categoryId;
              v.attrValue = v.categoryName;
              v.attrType = "category";
            });
            resolve(data);
          })
          .catch(err => {
            throw new Error(err);
          });
      } else {
        this.$store
          .dispatch("queryAttributeChildrenType", {
            typeId: node.data.attrId
          })
          .then(res => {
            const data = res.result;
            data.forEach(v => {
              v.attrId = v.attributeId;
              v.attrValue = v.userName;
              v.attrType = "attribute";
            });
            resolve(data);
          })
          .catch(err => {
            throw new Error(err);
          });
      }
    },
    selectQueryType(queryType) {
      if (queryType === "spu_name") {
        this.placeholder = "请输入商品名";
      } else if (queryType === "goods_sn") {
        this.placeholder = "请输入货号";
      } else if (queryType === "spec_barcode") {
        this.placeholder = "请输入条码";
      } else if (queryType === "brandName") {
        this.placeholder = "请输入品牌名";
      }
    },
    batchSetting() {
      if (this.checkedRowList.length) {
        this.$confirm("删除所有选中的结果？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.selectedData = this.selectedData.filter(
            v =>
              !this.checkedRowList.some(
                item => String(v.attrId) === String(item.attrId)
              )
          );
          this.result = this.selectedData;
          this.checkedRowList = [];
          const data = getCookie({ key: "STEP" });
          data.step3 = this.result;
          setCookie({ key: "STEP", data });
        });
      } else {
        this.$message({
          message: "请选择",
          type: "warning"
        });
      }
    },
    getBatchChecked(selection) {
      this.checkedRowList = selection;
    },
    remove(i) {
      this.selectedData.splice(i, 1);
      this.result = this.selectedData;
      // this.result.splice(i, 1);
    },
    addSelected(useable) {
      let rightChecked =
        this.type === "brand" ||
        this.type === "goods" ||
        this.type === "barcode"
          ? this.checkedRow
          : this.getSimpleCheckedNodes(this.$refs.tree.store);

      if (
        (rightChecked.find(o => o.attrType === "attribute") &&
          rightChecked.find(o => o.attrType !== "attribute")) ||
        (rightChecked.find(o => o.attrType === "attribute") &&
          this.selectedData.find(o => o.attrType !== "attribute")) ||
        (rightChecked.find(o => o.attrType !== "attribute") &&
          this.selectedData.find(o => o.attrType === "attribute"))
      ) {
        this.$message({
          type: "error",
          message: "属性标签不能与品牌、品类、商品共存！"
        });
      } else {
        if (
          this.type === "brand" ||
          this.type === "goods" ||
          this.type === "barcode"
        ) {
          if (this.checkedRow.length) {
            this.checkedRow.forEach(v => {
              v.useable = useable;
            });
            const data = this.selectedData.concat(this.checkedRow);
            this.selectedData = [...new Set(data)];
            this.selectedData = arrayUnique2(this.selectedData, "attrId");
            this.result = this.selectedData;
            this.dialogVisible = false;
            this.checkedRow = [];
          } else {
            this.$message({
              type: "error",
              message: "请选择"
            });
          }
        } else {
          const checkCateGoryList = this.getSimpleCheckedNodes(
            this.$refs.tree.store
          );

          if (checkCateGoryList.length) {
            checkCateGoryList.forEach(v => {
              v.useable = useable;
            });
            const data = this.selectedData.concat(checkCateGoryList);
            this.selectedData = [...new Set(data)];
            this.selectedData = arrayUnique2(this.selectedData, "attrId");
            this.result = this.selectedData;
            this.drawer = false;
          } else {
            this.$message({
              type: "error",
              message: "请选择"
            });
          }
        }
      }
    },
    searchAdd() {
      this.currentPageAdd = 1;
      this.queryAddList();
    },
    sortChange(sort) {
      this.sort = sort;
      this.queryAddList();
    },
    handleSizeChangeAdd(size) {
      this.pageSizeAdd = size;
      this.currentPageAdd = 1;
      this.queryAddList();
    },
    pagingAdd(page) {
      this.currentPageAdd = page;
      this.queryAddList();
    },
    async queryAddList() {
      let params = {
        pageNo: this.currentPageAdd,
        pageSize: this.pageSizeAdd
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      if (this.type === "brand") {
        params.order = this.sort.order;
        params.prop = this.sort.prop;
        const { result } = await this.$store.dispatch(
          "queryBrandActivityList",
          params
        );
        this.addList = result.records;
        this.addList.forEach(v => {
          v.attrValue = v.brandName;
          v.attrId = v.brandId;
          v.attrType = "brand";
        });
        this.totalAdd = result.total;
      } else if (this.type === "goods") {
        const { result } = await this.$store.dispatch(
          "queryMicroShopGoodsList",
          params
        );
        this.addList = result.records;
        this.addList.forEach(v => {
          v.attrValue = v.wxshopSpuName;
          v.goodsName = v.wxshopSpuName;
          v.attrId = v.goodsSn;
          v.shopPrice = v.showPrice;
          v.attrType = "goods";
        });
        console.log("this.addList: ", this.addList);
        this.totalAdd = result.total;
      } else if (this.type === "barcode") {
        const { result } = await this.$store.dispatch(
          "queryGoodsByBarcodePage",
          params
        );
        this.addList = result.records;
        this.addList.forEach(v => {
          v.attrValue = v.goodsName;
          v.attrId = v.barcode;
          v.attrType = "barcode";
          v.skuId = v.goodsId;
        });
        this.totalAdd = result.total;
      }
      this.$nextTick(() => {
        this.addList.map(v => {
          if (this.result.findIndex(o => o.attrId === v.attrId) >= 0) {
            this.$refs.table.toggleRowSelection(v);
          }
        });
      });
    },
    getChecked(selection) {
      this.checkedRow = selection;
    },
    add(type, title) {
      if (type === "goods") {
        this.searchCondition = {
          queryType: "spu_name"
        };
      } else {
        this.searchCondition = {};
      }
      this.addList = [];
      this.totalAdd = 0;
      this.title = title;
      this.type = type;
      this.queryAddList();
      this.dialogVisible = true;
    },
    addDrawer(type, title) {
      this.type = type;
      this.title = title;
      this.drawer = true;
    },
    nextStep() {
      if (this.result.length) {
        if (this.result.findIndex(v => v.useable === "white") >= 0) {
          const data = getCookie({ key: "STEP" });

          this.result.forEach(v => {
            v.selectUpperLimit = "";
            v.shopPrices = v.shopPrice;
            v.shopPrice = null;
          });

          data.step3 = this.result;
          setCookie({ key: "STEP", data });
          const route = { name: "CreatGoodsRule" };
          if (this.disabledFirst) {
            if (!this.subType) {
              Object.assign(route, {
                query: {
                  type: "edit"
                }
              });
            } else {
              Object.assign(route, {
                query: {
                  type: "edit",
                  subType: "copy"
                }
              });
            }
          }
          this.$router.push(route);
        } else {
          this.$message({
            type: "error",
            message: "请至少选择一个白名单！"
          });
        }
      } else {
        this.$message({
          type: "error",
          message: "请先添加商品！"
        });
      }
    },
    deleteSelected() {
      if (this.checkedGoods.length) {
        this.$confirm("删除所有选中的结果？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.selectedData = this.selectedData.filter(
            v =>
              !this.checkedGoods.some(
                item => String(v.attrId) === String(item.attrId)
              )
          );
          this.result = this.selectedData;
          this.checkedGoods = [];
          const data = getCookie({ key: "STEP" });
          data.step3 = this.result;
          setCookie({ key: "STEP", data });
        });
      } else {
        this.$message({
          type: "error",
          message: "请先选择商品"
        });
      }
    },
    handleCheckAllChange(val) {
      this.checkedGoods = val ? this.result : [];
      this.isIndeterminate = false;
    },
    handleCheckedGoodsChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.result.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.result.length;
    },
    filterGoods() {
      this.result = this.selectedData.filter(
        v =>
          v.attrId.includes(this.keywords) ||
          v.attrValue.includes(this.keywords)
      );
    },
    back() {
      this.$router.back(-1);
    },
    handleSelectionChange() {},
    saveSelected() {
      let rightChecked = this.$refs.ruleTransfer.rightChecked;
      if (
        (rightChecked.find(o => o.attrType === "attribute") &&
          rightChecked.find(o => o.attrType !== "attribute")) ||
        (rightChecked.find(o => o.attrType === "attribute") &&
          this.selectedData.find(o => o.attrType !== "attribute")) ||
        (rightChecked.find(o => o.attrType !== "attribute") &&
          this.selectedData.find(o => o.attrType === "attribute"))
      ) {
        this.$message({
          type: "error",
          message: "标签不能与品牌、品类、商品共存！"
        });
      } else {
        const data = this.selectedData.concat(rightChecked);
        this.selectedData = [...new Set(data)];
        this.selectedData = arrayUnique2(this.selectedData, "attrId");
        this.result = this.selectedData;
        this.dialogVisible = false;
      }
    },
    deleteCurrentGoods(v, i) {
      this.selectedData.splice(i, 1);
      this.result = this.selectedData;
    }
  },
  components: { HmStep }
};
</script>
<style lang="scss">
.list-item {
  .el-checkbox {
    margin: 0;
  }
  .el-checkbox__label {
    width: 100%;
  }
}
</style>

<style scoped lang="scss">
.table {
  // margin: 20px 0;
  // border: 1px solid #eaeaea;
  .delete {
    cursor: pointer;
    user-select: none;
  }
  .table-out-header,
  .no-message {
    padding: 12px;
  }
  .table-header {
    padding: 12px;
    background: #f7f7f7;
    font-size: 12px;
    .num {
      padding-left: 26px;
    }
  }
  .table-body {
    font-size: 12px;
    .row {
      padding: 12px;
      font-size: 12px;
    }
    .list-item:nth-child(even) {
      background: #f7f7f7;
    }
    .delete-icon {
      cursor: pointer;
      font-size: 12px;
    }
  }
}
</style>
